import React, { FC } from 'react'

import { IconConvergedPropositionProps } from './IconConvergedProposition.types'
import * as Styled from './styles/IconConvergedProposition.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConvergedProposition: FC<IconConvergedPropositionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConvergedPropositionProps['size'],
  isResponsive = false,
}: IconConvergedPropositionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.215 37h14.918m-20.548-4H35m-11 4v-4m15 4.995h2'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M38 24h7v15a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3V27a3 3 0 0 1 3-3Z' stroke='#fff' strokeLinecap='round' strokeWidth='2' />
        <path
          d='M26.375 24.97a3.368 3.368 0 0 0-4.75 0m7.125-2.987a6.735 6.735 0 0 0-9.518 0m11.9-3.01a10.102 10.102 0 0 0-14.265 0'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M7 23.19v-7.94A4.25 4.25 0 0 1 11.25 11H41v12.735m-6 9.26H10.875' stroke='#fff' strokeWidth='2' />
        <path
          d='m12.802 36.475 1.7-.583c.423-.067.81 0 1 .218.273.315 2.5 3.12 2.698 3.365.197.245.142.75-.345 1.108-.488.357-2.91 1.892-3.54 1.667-.63-.225-3.315-1.182-6.715-7.805-3.4-6.622-2.58-9.27-2.388-9.905.193-.635 2.83-1.725 3.413-1.898.582-.172 1.022.108 1.125.403.102.295 1.047 3.737 1.147 4.12.068.265-.107.613-.415.895-.307.283-1.54 1.373-1.54 1.373s.25 1.102 1.5 3.547c.583 1.18 2.36 3.495 2.36 3.495Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconConvergedProposition
